import React, { Children, useEffect, useRef, useState } from "react";

import Connection, { ConnectionType } from "../models/Connection";
import Scene from "../models/Scene";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";
import Page from "../models/Page";
import ConnectorGrab from "../components/ConnectorGrab";
import Button from "../models/Button";
import Room from "../models/Room";
import ConnectionTarget from "./ConnectionTarget";
import { PagePrintInfo } from "../models/PagePrintInfo";

export default function SceneConnecionView(props: {
  page: Page;
  connection: Connection;
  scene: Scene;
  print?: PagePrintInfo;
}) {
  const { connection, scene, page, print } = props;

  useOnChangeWatcher(scene);
  useOnChangeWatcher(connection);
  const [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
    if (isClicked) {
      showConnectionElement = connectionElements;
    } else {
      showConnectionElement = [];
    }
  }, [isClicked]);

  function SceneFunctionConnectionView(props: { sceneConnection: Connection }) {
    const { sceneConnection: Connection } = props;

    const partner = props.sceneConnection.getPartner(scene);
    if (connection) {
      return (
        <div style={{ fontSize: "0.75em", overflow: "hidden" }}>
          {/* <table>
           <tbody>
            <tr>
              <td> {"Name:"}</td>
              <td style={{ overflow: "hidden" }}>
                <div className="scrollableHidden">
                  <div style={{ width: "35px" }}>
                    <EditableText
                      obj={partner}
                      property="name"
                      propertyType="text"
                      style={{ padding: "0px" }}
                      maxCharacters={state.maxCharLimit.text}
                    />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>{"Verhalten:"}</td>
              <td>
                <div className="scrollableHidden">
                  <div style={{ width: "35px" }}>
                    <EditableText
                      obj={connection.knxSceneInfo}
                      property="value1"
                      propertyType="text"
                      style={{ padding: "0px" }}
                      maxCharacters={state.maxCharLimit.text}
                    />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>{"v:"}</td>
              <td>
                <div style={{ width: "35px" }}>
                  <div className="scrollableHidden">
                    <EditableText
                      obj={connection.knxSceneInfo}
                      property="value2"
                      propertyType="numeric"
                      style={{ padding: "0px" }}
                      maxCharacters={state.maxCharLimit.text}
                    />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>{"Helligkeit:"}</td>{" "}
              <td>
                <div className="scrollableHidden">
                  <div style={{ width: "35px" }}>
                    <EditableText
                      obj={connection.knxSceneInfo}
                      property="value3"
                      propertyType="numeric"
                      style={{ padding: "0px" }}
                      maxCharacters={state.maxCharLimit.text}
                    />
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          </table> */}
        </div>
      );
    }
    return <div></div>;
  }
  function SceneButtonConnectionView(props: { connection: Connection }) {
    const { connection } = props;

    const buttonChannel = connection.getPartner(scene);
    const button = buttonChannel?.parent as Button;
    const room = button?.parent as Room;

    return (
      <div style={{ fontSize: "0.75em" }}>
        {/* <tr style={{ flexDirection: "row" }}>
          <td> {"Name:"}</td>
          <td>
            <EditableText
              obj={partner}
              property="name"
              propertyType="text"
              style={{ padding: "0px" }}
              maxCharacters={state.maxCharLimit.text}
            />
          </td>
        </tr> */}
      </div>
    );
  }

  const partner = connection.getPartner(scene);
  var connectionName = partner?.tagOrName;
  var connectionIsOnPage = true;

  const connectionElements: any = [];
  var showConnectionElement: any = [];
  if (partner?.className == "ButtonChannel") {
    // the partner of this scene is a channel
    //push connector Grap for this connection
    connectionElements.push(
      <ConnectorGrab
        key="a"
        mainPage={page}
        page={page}
        connectableObject={scene}
        x={-3}
        portName={connection.id}
        type={ConnectionType.Scene}
        ownerSelected={false}
        disabled={print != undefined}
      />,
    );
    // push specification of the connection: name of the used Taster
    connectionElements.push(<SceneButtonConnectionView key="b" connection={connection} />);
    // get channel/taster Name from this connection (used at the end)
    connectionName = partner?.parent?.tagOrName + `/` + connectionName;
    if (partner?.parent?.parent?.tagOrName != page.parent?.tagOrName) {
      connectionIsOnPage = false;
      connectionName = partner?.parent?.parent?.tagOrName + `/` + connectionName;
      if (partner?.parent?.parent?.parent?.tagOrName != page.parent?.parent?.tagOrName) {
        connectionName = partner?.parent?.parent?.parent?.tagOrName + `/` + connectionName;
      }
    }
  } else {
    // the connection is a Consumer(Switch, dimm etc. )
    //push connector Grap for this connection
    connectionElements.push(
      <ConnectorGrab
        key="c"
        mainPage={page}
        page={page}
        connectableObject={scene}
        x={-3}
        portName={connection.id}
        type={ConnectionType.Scene}
        ownerSelected={false}
        disabled={print != undefined}
      />,
    );
    // push specification of this connection (behaviour, speed, brightness etc. )
    connectionElements.push(<SceneFunctionConnectionView key="d" sceneConnection={connection} />);

    // get the consumer Name from this connection(used at the end)
    if (partner?.parent?.tagOrName != page.parent?.tagOrName) {
      connectionIsOnPage = false;
      connectionName = partner?.parent?.tagOrName + `/` + connectionName;
      if (partner?.parent?.parent?.tagOrName != page.parent?.parent?.tagOrName) {
        connectionName = partner?.parent?.parent?.tagOrName + `/` + connectionName;
      }
    }
  }
  showConnectionElement = connectionElements;
  if (connectionIsOnPage) {
    return (
      <ConnectionTarget
        className="sceneConnections"
        page={page}
        target={scene}
        compact={2}
        connectionType={ConnectionType.Channel}
      >
        <div id={`sC-${connection.id}`}>
          <div
            onClick={() => {
              setIsClicked(!isClicked);
            }}
          >
            {connectionName}
          </div>
          {showConnectionElement}
        </div>
      </ConnectionTarget>
    );
  } else {
    return (
      <div
        className="sceneConnections"
        style={{
          height: "20px",
          backgroundColor: "var(--defaultBackgroundColor)",
        }}
        onClick={() => {
          state.navigate;
        }}
      >
        {connectionName}
      </div>
    );
  }
}
